import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=d8f0a3cc&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f0a3cc",
  null
  
)

export default component.exports